import { Dayjs } from 'dayjs';
import { useMemo } from 'react';
import { Job, JobStatus } from '@core/generated/gql-types';
import { doesJobWorkInDateRange } from '@/modules/jobs/utils/jobFilters.utils';
import { getPriorPeriod } from '@/modules/dashboard/utils/priorPeriod.utils';

/**
 * Jobs that had a working day in the period immediately before the selected
 * range. The jobs list must include that earlier period, not only the range
 * on screen.
 */
export const usePriorWeekData = (jobs: Job[], rangeStart: Dayjs, rangeEnd: Dayjs) => {
  const priorPeriod = useMemo(
    () => getPriorPeriod(rangeStart, rangeEnd),
    [rangeStart, rangeEnd],
  );

  const priorPeriodJobs = useMemo(
    () =>
      jobs.filter((job) =>
        doesJobWorkInDateRange(
          job,
          priorPeriod.start.toDate(),
          priorPeriod.end.toDate(),
        ),
      ),
    [jobs, priorPeriod],
  );

  const priorWeekFilledJobs = useMemo(
    (): Job[] =>
      priorPeriodJobs.filter(
        (job) =>
          job.itemStatus === JobStatus.Filled ||
          job.itemStatus === JobStatus.Completed,
      ),
    [priorPeriodJobs],
  );

  return {
    priorWeekFilledJobs,
    comparisonLabel: priorPeriod.comparisonLabel,
  };
};
